export enum CategorieMessage{
  INFOS_MARCHE = 'INFOS_MARCHE',
  VISION_MARCHE_ARTICLE = 'VISION_MARCHE_ARTICLE'
}
